export const FETCH_POINTS_PLUS_CASH = 'pointsPlusCash/FETCH';
export const FETCH_POINTS_PLUS_CASH_SUCCESS = 'pointsPlusCash/FETCH_SUCCESS';
export const FETCH_POINTS_PLUS_CASH_FAIL = 'pointsPlusCash/FETCH_FAIL';

/* eslint-disable */
const PointsPlusCashReducer = (state = {}, action = {}) => {
  switch (action.type) {
    case FETCH_POINTS_PLUS_CASH:
      return {
        ...state,
        [action.sku]: {
          isLoading: true,
          isLoaded: false,
          items: [],
        },
      };
    case FETCH_POINTS_PLUS_CASH_SUCCESS:
      return {
        ...state,
        [action.payload.sku]: {
          isLoading: false,
          isLoaded: true,
          items: action.payload.data,
        },
      };
    case FETCH_POINTS_PLUS_CASH_FAIL:
      return {
        ...state,
        [action.payload.sku]: {
          isLoaded: false,
          isLoading: false,
          error: action.error,
          items: [],
        },
      };
    default:
      return { ...state };
  }
};

export default PointsPlusCashReducer;
